import { render, staticRenderFns } from "./Blh.vue?vue&type=template&id=10924084&scoped=true&"
import script from "./Blh.vue?vue&type=script&lang=ts&"
export * from "./Blh.vue?vue&type=script&lang=ts&"
import style0 from "./Blh.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Blh.vue?vue&type=style&index=1&id=10924084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10924084",
  null
  
)

export default component.exports